import {Observable, Subscription} from 'rxjs';

import IFrameStore from '../Interfaces/IFrameStore';

const subscribeToFullscreenTap = (
    fullscreenTap$: Observable<void>,
    frameStore: IFrameStore
): Subscription =>
    fullscreenTap$
        .subscribe(() => {
            if (frameStore.value.isFrameFullscreened) {
                frameStore.actions.exitFullscreen();
            } else {
                frameStore.actions.enterFullscreen();
            }
        });

export default subscribeToFullscreenTap;